import graphql from 'babel-plugin-relay/macro';
import createMutation from '../../helpers/createMutation';

const mutation = graphql`
  mutation UserUpdateLocaleMutation($input: User__UpdateLocaleInput!) {
    userUpdateLocale(input: $input) {
      user {
        id
        dbId
        locale
      }
    }
  }
`;

const commit = input =>
  createMutation({
    mutation,

    variables: {
      input
    }
  });

export default { commit };
